
export * from './example/createExample';
export { default as createExample } from './example/createExample';

export * from './js_injector/js_injector';
export { default as JsInjector } from './js_injector/js_injector';

export * from './routes/routes';
export { default as Routes } from './routes/routes';

export * from './string/slugify';
export { default as Slugify } from './string/slugify';



/** WEBPACK FOOTER **
 ** ./src/guide/services/index.js
 **/